import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1611117775350-ac3950990985?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHwzZCUyMHByaW50aW5nJTIwcHJvdG90eXBlJTIwYmx1ZXxlbnwwfHx8fDE3OTI3NDMzNTl8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const bookConsultation = () => {
    window.dispatchEvent(new CustomEvent("goat:consultation"));
  };

  return (
    <header
      id="top"
      data-testid="hero-section"
      className="relative pt-16 pb-24 px-6 lg:px-12 border-b border-[#24283b] bg-[#0b0c10]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-2.5 h-2.5 rounded-full bg-[#45f3ff] animate-ping"></span>
          <span className="font-mono-goat text-xs uppercase tracking-widest text-[#45f3ff]">
            Turnkey Creative + Manufacturing
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-display uppercase tracking-tight text-white text-[clamp(44px,7.5vw,112px)] leading-[0.92] mb-8"
        >
          <span className="ln"><span>Ideas That Resonate,</span></span>
          <span className="ln">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#45f3ff] via-white to-[#6c72cb]">
              Designs That
            </span>
          </span>
          <span className="ln"><span>Captivate Audiences.</span></span>
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end pt-4">
          <div className="lg:col-span-6 space-y-6">
            <p
              data-testid="hero-subcopy"
              className="text-neutral-300 text-lg leading-relaxed max-w-xl hero-sub fade-in-goat"
            >
              End-to-end studio for startups and established brands nationwide. We engineer digital
              storefronts and manufacture tangible products under one unified roof.
            </p>

            <div className="flex flex-wrap gap-4 pt-2 hero-cta fade-in-goat">
              <a
                href="#quote"
                data-testid="hero-request-quote-btn"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#45f3ff] text-black font-mono-goat text-xs font-bold uppercase tracking-wider hover:bg-white transition-colors shadow-[0_0_30px_rgba(69,243,255,0.25)]"
              >
                Request Quote Form <ArrowRight className="w-3.5 h-3.5" />
              </a>
              <a
                href="#quote"
                onClick={bookConsultation}
                data-testid="hero-book-consultation-btn"
                className="inline-flex items-center px-6 py-3.5 border border-[#24283b] bg-[#161a29]/60 text-white font-mono-goat text-xs uppercase tracking-wider hover:border-[#45f3ff] transition-colors"
              >
                Book Consultation
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 hero-card fade-in-goat">
            <div className="relative overflow-hidden border border-[#24283b] bg-[#121624] p-3 shadow-2xl hero-wipe">
              <div className="w-full h-64 md:h-80 rounded-none relative overflow-hidden flex items-end">
                <img
                  src={HERO_IMG}
                  alt="Precision 3D physical prototype illuminated by blue spotlight"
                  data-testid="hero-image"
                  className="absolute inset-0 w-full h-full object-cover img-drift"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b0c10]/80 via-transparent to-transparent"></div>
                <svg
                  className="absolute inset-0 w-full h-full opacity-20 pointer-events-none"
                  viewBox="0 0 400 300"
                  stroke="#45f3ff"
                  strokeWidth="1"
                  fill="none"
                >
                  <path d="M0 50h400M0 100h400M0 150h400M0 200h400M0 250h400M50 0v300M100 0v300M150 0v300M200 0v300M250 0v300M300 0v300M350 0v300" />
                  <circle cx="200" cy="150" r="70" strokeWidth="2" />
                  <path d="M150 150h100M200 100v100" />
                </svg>
                <div className="relative z-10 m-3 bg-black/80 backdrop-blur-md px-4 py-2 border-l-2 border-[#45f3ff]">
                  <span className="font-mono-goat text-[10px] tracking-widest uppercase text-[#45f3ff]">
                    Hybrid Pipeline 01
                  </span>
                  <p className="font-mono-goat text-xs text-white">
                    Physical 3D Print • Custom Digital Launch
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
